import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Input, Modal, Space, Typography } from 'antd';
import { FC, useState } from 'react';

type Props = {
	open: boolean;
	onConfirm: (notes: string) => void;
	onCancel: () => void;
	loading?: boolean;
};

const ReturnConfirmModal: FC<Props> = ({ open, onConfirm, onCancel, loading }) => {
	const [notes, setNotes] = useState('');

	const handleConfirm = () => {
		onConfirm(notes);
		setNotes('');
	};

	const handleCancel = () => {
		setNotes('');
		onCancel();
	};

	return (
		<Modal
			open={open}
			onCancel={handleCancel}
			footer={null}
			closable={false}
			maskClosable={false}
			width={480}
		>
			<Space direction='vertical' style={{ width: '100%' }} size={16}>
				<Space align='start' size={12}>
					<InfoCircleOutlined style={{ fontSize: 22, color: '#1890ff', marginTop: 2 }} />
					<Typography.Text>
						Apakah Anda yakin untuk melakukan Return ke Modul Quality Control?
					</Typography.Text>
				</Space>
				<Input.TextArea
					rows={3}
					placeholder='Notes (opsional)'
					value={notes}
					onChange={(e) => setNotes(e.target.value)}
					disabled={loading}
				/>
				<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
					<Button onClick={handleCancel} disabled={loading}>
						Tidak
					</Button>
					<Button type='primary' loading={loading} onClick={handleConfirm}>
						Ya
					</Button>
				</div>
			</Space>
		</Modal>
	);
};

export default ReturnConfirmModal;
